// Per-browser preferences and records keyed by project (line spacing, the outliner's columns, findings left alone, the
// writing session, the last print build, scenes opened) are keyed by the project's *address* (client/net/address.ts):
// a project shared with this account by `<owner>/<id>`, so an owner's project and a member's own project with the same
// document id (the sample's, which every account has) never share a key. Pages read the core's `project.id`; the shell
// registers the open project's address here, and `storageId` maps that id to it. The account's own projects keep their
// id, as before.
let open: { coreId: string; address: string } | null = null;

/** The shell's open project: its documents' id and its address. Null when it closes. */
export function setOpenProject(coreId: string | null, address?: string) {
  open = coreId && address ? { coreId, address } : null;
}

/** The key to keep a project's per-browser things under, from its documents' id. */
export function storageId(coreId: string): string {
  return open && open.coreId === coreId && open.address.includes('/') ? open.address : coreId;
}
